import { api } from "../api.js";
import { h, fmtDate, eraLabel } from "../ui.js";
import type { App } from "../main.js";
import { progressBody } from "./home.js";

/** Public profile and hiscores — routes exist from day one; data arrives when the game emits it. */
export function profileView(_app: App, handle: string): HTMLElement {
  const box = h("div", { class: "stack" }, h("p", { class: "dim" }, "Loading…"));
  void api.profile(handle).then((r) => box.replaceChildren(
    h("div", { class: "panel" },
      h("h1", {}, r.profile.handle),
      h("p", { class: "dim mono-num" }, `${eraLabel(r.profile.era)} · since ${fmtDate(r.profile.since)}`),
    ),
    h("div", { class: "panel" }, h("h2", {}, "Progress"), progressBody(r.skills, r.floors, null, null)),
    // Boss kills (Root; Chase 2026-10-17): the first-kill mark with its date, the count, the fastest.
    h("div", { class: "panel" }, h("h2", {}, "Bosses"), ...(r.bosses?.length
      ? r.bosses.map((b) => h("p", { class: "mono-num" }, `◆ ${b.name} — first kill ${fmtDate(b.firstAt)} · ${b.kills} kill${b.kills === 1 ? "" : "s"} · fastest ${clock(b.bestTicks)}`))
      : [h("p", { class: "dim" }, "None yet.")])),
    h("div", { class: "panel" }, h("h2", {}, "Hiscores"), h("p", { class: "dim" }, "No runs recorded.")),
    h("div", { class: "panel" }, h("h2", {}, "Collection log"), h("p", { class: "dim" }, "Empty.")),
  )).catch(() => box.replaceChildren(h("div", { class: "msg error" }, `No profile named ${handle} in this era.`)));
  return box;
}

export function hiscoresView(_app: App): HTMLElement {
  return h("div", { class: "stack" },
    h("div", { class: "panel" }, h("h1", {}, "Hiscores"), h("p", { class: "dim" }, "Boards appear once verified runs exist. Every board is a view over the event stream (architecture §10).")),
    h("div", { class: "overflow" }, h("table", {}, h("thead", {}, h("tr", {}, h("th", {}, "#"), h("th", {}, "Handle"), h("th", {}, "Depth"), h("th", {}, "When"))), h("tbody", {}, h("tr", {}, h("td", { colspan: "4", class: "dim" }, "—"))))),
  );
}

/** Sim ticks (60 a second) as m:ss. */
function clock(ticks: number): string { const sec = Math.round(ticks / 60); return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, "0")}`; }
